import React, { useState } from "react";
import { Grid2 as Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { PersonAdd, ExpandMore } from '@mui/icons-material';
import { BoxSpaceCenter } from "../style/box";
import { RegisterButton } from "../style/button";
import { TypographyBold } from '../style/typography';
import { CustomControlledInput } from "./CustomControlledInput";

const RecipientRegistration = ({ control, sendCategories, openDialog, handleRegistSubmit, expanded = false, isDisabled }) => {
    const [isExpanded, setIsExpanded] = useState(expanded);

    return (
        <Grid size={{ xs: 12 }}>
            <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="recipient-registration-content"
                    id="recipient-registration-header"
                >
                    <TypographyBold>新規送付先登録</TypographyBold>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={3}>
                        {/* 氏名 */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <CustomControlledInput
                                name="registRecipient.name"
                                control={control}
                                label="氏名"
                                variant="outlined"
                                placeholder="山田太郎"
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 部署名、肩書 */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <CustomControlledInput
                                name="registRecipient.department_name"
                                control={control}
                                label="部署名、肩書"
                                variant="outlined"
                                placeholder="総務部課長"
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* メールアドレス */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <CustomControlledInput
                                name="registRecipient.email"
                                control={control}
                                label="メールアドレス"
                                variant="outlined"
                                placeholder="example@kyuden.co.jp"
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 送付先カテゴリ */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <CustomControlledInput
                                name="registRecipient.send_category"
                                control={control}
                                label="送付先カテゴリ"
                                type="select"
                                multiple={false}
                                options={sendCategories.map((c) => ({
                                    value: c.value,
                                    label: c.label
                                }))}
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 登録ボタン */}
                        <Grid container size={{ xs: 12 }} justifyContent="center">
                            <Grid size={{ xs: 12, md: 6 }}>
                                <BoxSpaceCenter>
                                    <form
                                        style={{ width: "100%" }}
                                        onSubmit={handleRegistSubmit((data) => { openDialog('register', data.registRecipient); })}
                                    >
                                        <RegisterButton
                                            fullWidth
                                            type="submit"
                                            variant="contained"
                                            startIcon={<PersonAdd />}
                                            disabled={isDisabled}
                                        >
                                            送付先を登録
                                        </RegisterButton>
                                    </form>
                                </BoxSpaceCenter>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};

export default RecipientRegistration;